import React from "react";
import QRCode from "react-qr-code";
import { useTranslation } from "react-i18next";
import { SeatBookingItemStyled } from "./styled";
import { RenderCommaMoney } from "utils/functions/formatMoney";
import {
  BOOKING_STATUS,
  RENDER_SEAT_BOOKING_STATUS,
  SEAT_BOOKING_DATE_TEXT,
} from "utils/functions/seatBooking";

// การ์ดใบจองหนึ่งใบในหน้ากิจกรรม (S7 รอตรวจสลิป / S8 จองสำเร็จ + ตั๋วต่อที่นั่ง) ลูกค้าจองได้หลายใบ
// ตาม design ชื่อผู้จองมีลำดับอยู่นอกการ์ด ("1. ชื่อ (ผู้จอง) · 2 ที่นั่ง")
const SeatBookingItem = ({ booking, index = 0 }) => {
  const { t, i18n } = useTranslation(["seat"]);
  const status = RENDER_SEAT_BOOKING_STATUS(booking.status);
  const isPending = booking.status === BOOKING_STATUS.PENDING;
  const isApproved = booking.status === BOOKING_STATUS.APPROVED;
  const seatIds = booking.seats.map((s) => s.seat_id).join(", ");

  return (
    <SeatBookingItemStyled>
      <div className="sbi_booker">
        {index + 1}. {booking.booker_name || "-"} ({t("Booker", { ns: "seat" })}) ·{" "}
        {t("{{count}} seats", { ns: "seat", count: booking.seats.length })}
      </div>
      <div className="sbi_card">
        <div className="sbi_status" style={{ background: status.bgColor, color: status.txtColor }}>
          {t(status.labelKey, { ns: "seat" })}
        </div>

        <div className="sbi_payment">
          <div className="sbi_label">{t("Payment details", { ns: "seat" })}</div>
          <div className="sbi_text">
            {t("Booking code", { ns: "seat" })} {booking.code} · {t("Seat", { ns: "seat" })} {seatIds}
          </div>
          <div className="sbi_amount_row">
            <span>{t("Transfer amount", { ns: "seat" })}</span>
            <span className="sbi_amount">
              {RenderCommaMoney(booking.amount)} {t("THB", { ns: "seat" })}
            </span>
          </div>
        </div>

        {isPending && (
          <div className="sbi_note">
            {t("Submitted on {{time}}. Verified within 24 hrs.", {
              ns: "seat",
              time: SEAT_BOOKING_DATE_TEXT(booking.submitted_at, i18n.language),
            })}
          </div>
        )}

        {isApproved && (
          <>
            <div className="sbi_tickets">
              {booking.seats.map((s, i) => (
                <div className={`sbi_ticket${s.used_at ? " used" : ""}`} key={s.seat_id}>
                  <div className="ticket_title">
                    {t("Ticket {{no}}/{{total}}", { ns: "seat", no: i + 1, total: booking.seats.length })} ·{" "}
                    {t("Seat", { ns: "seat" })} {s.seat_id}
                    {s.viewer_name ? ` · ${s.viewer_name}` : ""}
                  </div>
                  {s.used_at ? (
                    <div className="ticket_qr ticket_used">
                      {t("Entered at {{time}}", {
                        ns: "seat",
                        time: SEAT_BOOKING_DATE_TEXT(s.used_at, i18n.language),
                      })}
                    </div>
                  ) : (
                    s.ticket_qr && (
                      <div className="ticket_qr">
                        <QRCode value={s.ticket_qr} style={{ width: "100%", height: "auto" }} />
                      </div>
                    )
                  )}
                </div>
              ))}
            </div>
            <div className="sbi_note">
              {t("Tickets can be scanned on the event day only, once per seat", { ns: "seat" })}
            </div>
          </>
        )}

        {booking.status === BOOKING_STATUS.REJECTED && (
          <div className="sbi_note">
            {t("Reason", { ns: "seat" })}: {booking.reject_reason || "-"} · {t("The seats have been released", { ns: "seat" })}
          </div>
        )}
        {booking.status === BOOKING_STATUS.CANCELLED_BY_ADMIN && (
          <div className="sbi_note">
            {t("Reason", { ns: "seat" })}: {booking.cancel_reason || "-"}
          </div>
        )}
      </div>
    </SeatBookingItemStyled>
  );
};

export default SeatBookingItem;
